import React, { FC } from 'react'
import { type TFunction } from 'i18next'
import { useTranslation } from 'react-i18next'
import ErrorTemplate from '../../components/Error/ErrorTemplate'

const ServerErrorPage: FC = () => {
    // Global
    const { t }: { t: TFunction } = useTranslation('error')

    return (
        <div className='server-error-page'>
            <ErrorTemplate h1={t('error-page.server-error.h1')} />
        </div>
    )
}

export default ServerErrorPage
